module.exports = __webpack_public_path__ + "img/iconico_boccale.2a327aa5.png";